<template>
  <v-dialog v-model="visible" :width="width" persistent>
    <div class="confirm-dialog p-4">
      <p v-html="messageHtml"></p>
      <div class="text-center mt-4">
        <button v-if="cancelButtonLabel" class="btn-back mr-2" @click="onCancel">
          {{ cancelButtonLabel }}
        </button>
        <button v-if="confirmButtonLabel" class="btn-back" @click="onConfirm">
          {{ confirmButtonLabel }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "CustomDialog",

  props: {
    value: { type: Boolean, default: undefined },
    modelValue: { type: Boolean, default: undefined },
    message: { type: String, default: "Are you sure?" },
    width: { type: [Number, String], default: 500 },
    confirmButtonLabel: { type: String, default: "ใช่" },
    cancelButtonLabel: { type: String, default: "ปิด" },
    messageHtmlUnsafe: { type: Boolean, default: false }
  },

  computed: {
    visible: {
      get() {
        if (this.modelValue !== undefined) return this.modelValue;
        return this.value;
      },
      set(val) {
        this.$emit("update:modelValue", val);
        this.$emit("input", val);
      }
    },
    messageHtml() {
      if (this.messageHtmlUnsafe) return this.message;
      return this.message;
    }
  },

  methods: {
    onConfirm() {
      this.$emit("confirm");
      this.visible = false;
    },
    onCancel() {
      this.visible = false;
    }
  }
};
</script>

<style scoped>
.confirm-dialog {
  left: 50% !important;
  background: #fff;
  padding: 2rem;
}
.confirm-dialog p {
  font-size: 20px;
  padding-bottom: 2rem;
  text-align: center;
  font-weight: bold;
}
.btn-back {
  border: 1px solid #1976d2;
  width: 28%;
  height: 39px;
  border-radius: 25px;
  color: #1976d2;
}
.btn-back:hover { text-decoration: underline; }
</style>
